import Swiper, { Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';

export const Columns = ( el ) => {
	const ui = {
		el,
		swiper: el.querySelector('.columns__swiper-container'),
		swiperScrollbar: el.querySelector('.swiper-scrollbar')
	};

	Swiper.use( [ Scrollbar ] );

	// Breakpoint where swiper will be destroyed, or switch to multi-column
	const breakpoint = window.matchMedia( '(min-width: 720px)' );
	
	// Track swiper instance to destroy later
	let swiperObj;
	
	// Switch layout depending on breakpoint test
	const breakpointChecker = () => {
   		if ( breakpoint.matches === true ) {
			// Clean up old instance
      		if ( swiperObj !== undefined ) swiperObj.destroy( true, true );
      		return;
   		} else if ( breakpoint.matches === false ) {      
			// Enable small viewport version of swiper
      		return enableSwiper();   
		}
	};
	
	const enableSwiper = () => { 
		swiperObj = new Swiper (ui.swiper, { 
			centeredSlides: false,
			loop: false,
			spaceBetween: 10,
			slidesPerView: 1.2,
			speed: 300,
			scrollbar: {
				el: ui.swiperScrollbar,
				draggable: true,
			},
		});
	};
	
	// Track viewport size changes
	breakpoint.addListener(breakpointChecker);
	
	// Init
	breakpointChecker();
};

export default Columns;
